export default __webpack_public_path__ + "static/fumc-social-logo-95473820908c7bf41c125d7ec84f5f9a.jpg";